import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import Form from './Form';
import * as API from '../core/api';
import { catchFormErrors } from '../utils/form-errors';
import { requestDataIfNeeded as requestProjectMemos } from './duck';
import { requestDataIfNeeded as requestUserGoalMemos } from '../goals/memos/duck';

class Edit extends React.Component {
  handleSubmit = ({ content }, dispatch, { memoId, projectId, userId }) => {
    const { requestProjectMemos, onSuccess, requestUserGoalMemos } = this.props;

    return (
      API.put(`memos/${memoId}`, { content })
        // Refresh the memos
        .then(() => {
          if (projectId) {
            requestProjectMemos({ project: projectId });
          } else if (userId) {
            requestUserGoalMemos({ user: userId });
          }
        })
        .then(onSuccess)
        .catch(catchFormErrors)
    );
  };

  render() {
    const { t, project, memo, user, type } = this.props;

    return (
      <Form
        form={`project-memo-edit-${memo._id}`}
        initialValues={{ content: memo.content }}
        projectId={project && project._id}
        memoId={memo._id}
        userId={user && user._id}
        okButtonText={t('project.memo.submit')}
        onSubmit={this.handleSubmit}
        type={type}
      />
    );
  }
}

Edit.defaultProps = {
  type: 'PROJECT',
};

Edit.propTypes = {
  type: PropTypes.oneOf(['PROJECT', 'GOAL']),
};

const mapDispatchToProps = {
  requestProjectMemos,
  requestUserGoalMemos,
};

export default connect(
  null,
  mapDispatchToProps
)(translate()(Edit));



// WEBPACK FOOTER //
// ./src/memos/Edit.js